import chatModule from '../chatModule';

const eventNames = {
  chatLandingConversationClicked: 'chatLandingConversationClicked',
  conversationMessageSent: 'conversationMessageSent',
  webChatConversationsLoaded: 'webChatConversationsLoaded',
  webChatRendered: 'webChatRendered'
};

chatModule.constant('eventNames', eventNames);

export default eventNames;
